import { useQuery } from "react-query";
import { Get } from "../utils/api";
import { Organization } from "../../types/api/User";

export default (inviteId: string) => {
  return useQuery<Organization>(
    `invite_metadata_${inviteId}`,
    async () => Get(`/api/invite/metadata/invite/${inviteId}`, "None"),
    {
      retry: false,
    }
  );
};
